import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import { Home, Phone, Email } from '@mui/icons-material';
import { Container, Fab, Fade, Tooltip, useScrollTrigger } from '@mui/material';
import logo from "../Fichiers/Logo.png"
import logoNoel from "../Fichiers/LogoNoel.png"
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Langue from './Langue';
import { Link } from 'react-router-dom';
import SearchPage from './SearchPage';
import MenuMobile from './MenuMobile';
import { t } from 'i18next';
import ReseauxSociaux from './ReseauxSociaux';

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
  children?: React.ReactElement;
}

const drawerWidth = 240;
export default function DrawerAppBar(props: Props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [mois, setMois] = React.useState((((new Date(Date.now()))).getMonth()+1))

  setTimeout(()=>{
    setMois((((new Date(Date.now()))).getMonth()+1))
  }, 1000)
  // {(mois == 12 || mois == 1)? logoNoel : logo}

  
  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  function ScrollTop(props: Props) {
    const { children, window } = props;
    const trigger = useScrollTrigger({
      target: window ? window() : undefined,
      disableHysteresis: true,
      threshold: 100,
    });

    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
      const anchor = (
        (event.target as HTMLDivElement).ownerDocument || document
      ).querySelector('#back-to-top-anchor');

      if (anchor) {
        anchor.scrollIntoView({
          block: 'center',
        });
      }
    };

    return (
      <Fade in={trigger}>
        <Tooltip title={t("Label.Titre.titre44")}>
          <Box
            onClick={handleClick}
            role="presentation"
            sx={{ position: 'fixed', bottom: 200, right: 20 }}
          >
            {children}
          </Box>
        </Tooltip>
      </Fade>
    );
  }
  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex' }}>
      <Toolbar id="back-to-top-anchor" />

      <Box zIndex={1}>
        <ScrollTop {...props}>
          <Fab color='warning' size="small" aria-label="scroll back to top">
            <KeyboardArrowUpIcon />
          </Fab>
        </ScrollTop>
      </Box>

      <AppBar position="fixed" variant='outlined' style={{ background: "#F1FFF8", border: "none", boxShadow: "0px 3px 20px rgba(0, 0, 0, .1)", zIndex: "2" }} component="nav">
        <Container maxWidth="lg">
          <Toolbar>
            <IconButton
              color="success"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: 'none' } }}
            >
              <MenuIcon />
            </IconButton>
            <Box display={{ xs: 'block', sm: 'flex' }} gap={2}>
              <Link to={'/'}><img className={'logo'} width={"90%"} src={(mois === 12 || mois === 1)? logoNoel : logo} alt="" /></Link>
              <Box display={"flex"}>
                <Box padding={1} gap={1} display={'flex'}>
                  <Box style={{ marginLeft: '0%' }} className='header-icon'><IconButton size='small' color='success'><Home /></IconButton></Box>
                  <Box width={150} display={{ xs: 'none', sm: 'block' }} >
                    <label className='primaryText'>{t("ENTETE.siege")}</label><br />
                    <label className='seconderyText'>{t("ENTETE.ville")}</label>
                  </Box>
                </Box>

                <Box padding={1} gap={1} display={'flex'}>
                  <Box style={{ marginLeft: '0%' }} className='header-icon'><IconButton size='small' color='success'><Phone /></IconButton></Box>
                  <Box width={150} display={{ xs: 'none', sm: 'block' }} >
                    <label className='primaryText'>{t("ENTETE.telephone")}</label><br />
                    <label className='seconderyText'>{t("ENTETE.numero")}</label>
                  </Box>
                </Box>

                <Box padding={1} gap={1} display={'flex'}>
                  <Box style={{ marginLeft: '0%' }} className='header-icon'><IconButton size='small' color='success'><Email /></IconButton></Box>
                  <Box width={150} display={{ xs: 'none', sm: 'block' }} >
                    <label className='primaryText'>Email</label><br />
                    <label className='seconderyText'>contact@mupeci.cm</label>
                  </Box>
                  <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                    <Langue />
                  </Box>
                </Box>
              </Box>
              <Box padding={1} sx={{ display: { xs: 'none', sm: 'block' } }}>
                <Box gap={1} display={"flex"}>
                  <ReseauxSociaux />
                  <hr />
                  <SearchPage />
                </Box>
              </Box>
            </Box>
            <Box sx={{ display: { xs: 'none', sm: 'flex' } }} className="right">
              <Langue />
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          <Link to={"/"}><img alt="" style={{padding: "10%"}} width={"80%"} src={(mois === 12 || mois === 1)? logoNoel : logo} /></Link>
          <Divider />
          <MenuMobile />
          <Divider /><br />
          <center style={{width: "100%", fontSize: "small"}} className='textgray'>{t("copyright")}</center>
        </Drawer>
      </nav>
    </Box>
  );
}
